export const entityConfigs = {
  users: {
    labels: {
      singular: { en: "User", ar: "مستخدم" },
      plural: { en: "Users", ar: "المستخدمون" },
    },
    icon: "Users",
    searchFields: ["name", "phone_number", "role_name"],
    tableColumns: [
      { key: "first_name", label: { en: "Name", ar: "الاسم الأول" }, sortable: true },
      { key: "last_name", label: { en: "Name", ar: "العائلة" }, sortable: true },
      {
        key: "phone_number",
        label: { en: "Phone Number", ar: "رقم الهاتف" },
        sortable: true,
      },
      {
        key: "role_name",
        label: { en: "User Type", ar: "نوع المستخدم" },
        sortable: true,
        badge: true,
      },
    ],
    formFields: [
      {
        key: "first_name",
        type: "text",
        label: { en: "Name", ar: "الاسم" },
        required: true,
        validation: (v) => (v?.trim() ? null : "required"),
      },
      {
        key: "phone_number",
        type: "text",
        label: { en: "Phone Number", ar: "رقم الهاتف" },
        required: true,
        validation: (v) => {
          if (!v?.trim()) return "required";
          if (!/^[+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,9}$/.test(v))
            return "invalidPhone";
          return null;
        },
      },
      {
        key: "role_name",
        type: "select",
        label: { en: "User Type", ar: "نوع المستخدم" },
        required: true,
        options: [
          { value: "Client", label: { en: "Client", ar: "عميل" } },
          { value: "Workshop", label: { en: "Workshop", ar: "ورشة" } },
          { value: "Agency", label: { en: "Agency", ar: "وكالة" } },
          {
            value: "Emergency Provider",
            label: { en: "Emergency Provider", ar: "مزود طوارئ" },
          },
        ],
        validation: (v) => (v ? null : "required"),
      },
    ],
  },

  workshops: {
    labels: {
      singular: { en: "Workshop", ar: "ورشة" },
      plural: { en: "Workshops", ar: "الورش" },
    },
    icon: "Wrench",
    searchFields: ["name", "location.address"],
    tableColumns: [
      { key: "name", label: { en: "Name", ar: "الاسم" }, sortable: true },
      {
        key: "location.address",
        label: { en: "Address", ar: "العنوان" },
        sortable: false,
      },
      {
        key: "service_types",
        label: { en: "Services", ar: "الخدمات" },
        sortable: false,
        array: true,
      },
    ],
    formFields: [
      {
        key: "name",
        type: "text",
        label: { en: "Workshop Name", ar: "اسم الورشة" },
        required: true,
        validation: (v) => (v?.trim() ? null : "required"),
      },
      {
        key: "images",
        type: "file",
        label: { en: "Images", ar: "الصور" },
        required: false,
        multiple: true,
      },
      {
        key: "location.lat",
        type: "number",
        label: { en: "Latitude", ar: "خط العرض" },
        required: true,
        validation: (v) =>
          !v ? "required" : isNaN(v) ? "invalidCoordinates" : null,
      },
      {
        key: "location.lng",
        type: "number",
        label: { en: "Longitude", ar: "خط الطول" },
        required: true,
        validation: (v) =>
          !v ? "required" : isNaN(v) ? "invalidCoordinates" : null,
      },
      {
        key: "location.address",
        type: "text",
        label: { en: "Address", ar: "العنوان" },
        required: true,
        validation: (v) => (v?.trim() ? null : "required"),
      },
      {
        key: "service_types",
        type: "multiselect",
        label: { en: "Service Types", ar: "أنواع الخدمات" },
        required: true,
        options: [
          {
            value: "Oil Change",
            label: { en: "Oil Change", ar: "تغيير الزيت" },
          },
          {
            value: "Brake Repair",
            label: { en: "Brake Repair", ar: "إصلاح الفرامل" },
          },
          {
            value: "Engine Diagnostics",
            label: { en: "Engine Diagnostics", ar: "تشخيص المحرك" },
          },
          {
            value: "Tire Replacement",
            label: { en: "Tire Replacement", ar: "استبدال الإطارات" },
          },
          {
            value: "AC Repair",
            label: { en: "AC Repair", ar: "إصلاح التكييف" },
          },
          { value: "Paint Job", label: { en: "Paint Job", ar: "طلاء" } },
          {
            value: "Body Work",
            label: { en: "Body Work", ar: "أعمال الهيكل" },
          },
          {
            value: "Detailing",
            label: { en: "Detailing", ar: "تنظيف تفصيلي" },
          },
        ],
        validation: (v) => (v?.length ? null : "required"),
      },
    ],
  },

  agencies: {
    labels: {
      singular: { en: "Agency", ar: "وكالة" },
      plural: { en: "Agencies", ar: "الوكالات" },
    },
    icon: "Building2",
    searchFields: ["name", "location.address"],
    tableColumns: [
      { key: "name", label: { en: "Name", ar: "الاسم" }, sortable: true },
      {
        key: "location.address",
        label: { en: "Address", ar: "العنوان" },
        sortable: false,
      },
      {
        key: "service_types",
        label: { en: "Services", ar: "الخدمات" },
        sortable: false,
        array: true,
      },
    ],
    formFields: [
      {
        key: "name",
        type: "text",
        label: { en: "Agency Name", ar: "اسم الوكالة" },
        required: true,
        validation: (v) => (v?.trim() ? null : "required"),
      },
      {
        key: "images",
        type: "file",
        label: { en: "Images", ar: "الصور" },
        required: false,
        multiple: true,
      },
      {
        key: "location.lat",
        type: "number",
        label: { en: "Latitude", ar: "خط العرض" },
        required: true,
        validation: (v) =>
          !v ? "required" : isNaN(v) ? "invalidCoordinates" : null,
      },
      {
        key: "location.lng",
        type: "number",
        label: { en: "Longitude", ar: "خط الطول" },
        required: true,
        validation: (v) =>
          !v ? "required" : isNaN(v) ? "invalidCoordinates" : null,
      },
      {
        key: "location.address",
        type: "text",
        label: { en: "Address", ar: "العنوان" },
        required: true,
        validation: (v) => (v?.trim() ? null : "required"),
      },
      {
        key: "service_types",
        type: "multiselect",
        label: { en: "Service Types", ar: "أنواع الخدمات" },
        required: true,
        options: [
          {
            value: "Car Sales",
            label: { en: "Car Sales", ar: "مبيعات السيارات" },
          },
          { value: "Leasing", label: { en: "Leasing", ar: "التأجير" } },
          { value: "Insurance", label: { en: "Insurance", ar: "التأمين" } },
          { value: "Financing", label: { en: "Financing", ar: "التمويل" } },
          { value: "Trade-In", label: { en: "Trade-In", ar: "استبدال" } },
          { value: "Maintenance", label: { en: "Maintenance", ar: "الصيانة" } },
        ],
        validation: (v) => (v?.length ? null : "required"),
      },
    ],
  },

  emergency: {
    labels: {
      singular: { en: "Emergency Provider", ar: "مزود طوارئ" },
      plural: { en: "Emergency Providers", ar: "مزودو الطوارئ" },
    },
    icon: "AlertCircle",
    searchFields: ["name", "service_type", "whatsapp_number"],
    tableColumns: [
      { key: "name", label: { en: "Name", ar: "الاسم" }, sortable: true },
      {
        key: "service_type",
        label: { en: "Service Type", ar: "نوع الخدمة" },
        sortable: true,
        badge: true,
      },
      {
        key: "whatsapp_number",
        label: { en: "WhatsApp", ar: "واتساب" },
        sortable: false,
      },
    ],
    formFields: [
      {
        key: "name",
        type: "text",
        label: { en: "Provider Name", ar: "اسم المزود" },
        required: true,
        validation: (v) => (v?.trim() ? null : "required"),
      },
      {
        key: "service_type",
        type: "select",
        label: { en: "Service Type", ar: "نوع الخدمة" },
        required: true,
        options: [
          { value: "Electrician", label: { en: "Electrician", ar: "كهربائي" } },
          { value: "Car Wash", label: { en: "Car Wash", ar: "غسيل سيارات" } },
          { value: "Tow Truck", label: { en: "Tow Truck", ar: "سحب سيارات" } },
          { value: "Locksmith", label: { en: "Locksmith", ar: "صانع أقفال" } },
          {
            value: "Tire Service",
            label: { en: "Tire Service", ar: "خدمة الإطارات" },
          },
          {
            value: "Battery Service",
            label: { en: "Battery Service", ar: "خدمة البطارية" },
          },
        ],
        validation: (v) => (v ? null : "required"),
      },
      {
        key: "whatsapp_number",
        type: "text",
        label: { en: "WhatsApp Number", ar: "رقم واتساب" },
        required: true,
        validation: (v) => {
          if (!v?.trim()) return "required";
          if (!/^[+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,9}$/.test(v))
            return "invalidPhone";
          return null;
        },
      },
      {
        key: "location.lat",
        type: "number",
        label: { en: "Latitude (Optional)", ar: "خط العرض (اختياري)" },
        required: false,
        validation: (v) => (v && isNaN(v) ? "invalidCoordinates" : null),
      },
      {
        key: "location.lng",
        type: "number",
        label: { en: "Longitude (Optional)", ar: "خط الطول (اختياري)" },
        required: false,
        validation: (v) => (v && isNaN(v) ? "invalidCoordinates" : null),
      },
      {
        key: "active",
        type: "checkbox",
        label: { en: "Active", ar: "نشط" },
        required: false,
        defaultValue: true,
      },
    ],
  },

  products: {
    labels: {
      singular: { en: "Product", ar: "منتج" },
      plural: { en: "Products", ar: "المنتجات" },
    },
    icon: "Package",
    searchFields: ["name", "car_type", "description"],
    tableColumns: [
      { key: "name", label: { en: "Name", ar: "الاسم" }, sortable: true },
      {
        key: "price",
        label: { en: "Price", ar: "السعر" },
        sortable: true,
        price: true,
      },
      {
        key: "car_type",
        label: { en: "Car Type", ar: "نوع السيارة" },
        sortable: true,
        badge: true,
      },
    ],
    formFields: [
      {
        key: "name",
        type: "text",
        label: { en: "Product Name", ar: "اسم المنتج" },
        required: true,
        validation: (v) => (v?.trim() ? null : "required"),
      },
      {
        key: "images",
        type: "file",
        label: { en: "Images", ar: "الصور" },
        required: false,
        multiple: true,
      },
      {
        key: "price",
        type: "number",
        label: { en: "Price", ar: "السعر" },
        required: true,
        validation: (v) =>
          !v ? "required" : isNaN(v) || v <= 0 ? "invalidPrice" : null,
      },
      {
        key: "car_type",
        type: "select",
        label: { en: "Car Type", ar: "نوع السيارة" },
        required: true,
        options: [
          { value: "Sedan", label: { en: "Sedan", ar: "سيدان" } },
          { value: "SUV", label: { en: "SUV", ar: "دفع رباعي" } },
          { value: "Coupe", label: { en: "Coupe", ar: "كوبيه" } },
          { value: "Truck", label: { en: "Truck", ar: "شاحنة" } },
          { value: "Van", label: { en: "Van", ar: "فان" } },
          { value: "Universal", label: { en: "Universal", ar: "عام" } },
        ],
        validation: (v) => (v ? null : "required"),
      },
      {
        key: "description",
        type: "textarea",
        label: { en: "Description", ar: "الوصف" },
        required: true,
        validation: (v) => (v?.trim() ? null : "required"),
      },
    ],
  },

  carTypes: {
    labels: {
      singular: { en: "Car Type", ar: "نوع السيارة" },
      plural: { en: "Car Types", ar: "أنواع السيارات" },
    },
    icon: "Car",
    searchFields: ["type", "model"],
    tableColumns: [
      { key: "type", label: { en: "Type", ar: "النوع" }, sortable: true },
      { key: "model", label: { en: "Model", ar: "الموديل" }, sortable: true },
      { key: "year", label: { en: "Year", ar: "السنة" }, sortable: true },
    ],
    formFields: [
      {
        key: "type",
        type: "text",
        label: { en: "Type", ar: "النوع" },
        required: true,
        validation: (v) => (v?.trim() ? null : "required"),
      },
      {
        key: "model",
        type: "text",
        label: { en: "Model", ar: "الموديل" },
        required: true,
        validation: (v) => (v?.trim() ? null : "required"),
      },
      {
        key: "year",
        type: "number",
        label: { en: "Year", ar: "السنة" },
        required: true,
        validation: (v) => {
          if (!v) return "required";
          const y = parseInt(v);
          return isNaN(y) || y < 1900 || y > 2100 ? "invalidYear" : null;
        },
      },
      {
        key: "related_workshops",
        type: "multiselect",
        label: { en: "Related Workshops", ar: "الورش المرتبطة" },
        required: false,
        options: [],
      },
      {
        key: "related_agencies",
        type: "multiselect",
        label: { en: "Related Agencies", ar: "الوكالات المرتبطة" },
        required: false,
        options: [],
      },
      {
        key: "related_products",
        type: "multiselect",
        label: { en: "Related Products", ar: "المنتجات المرتبطة" },
        required: false,
        options: [],
      },
    ],
  },
};
